<template>
  <div class="multiDimensional-info">
    <el-tabs v-model="activeName" tab-position="right" @tab-click="handleClick" @before-leave="beforeLeave">
      <el-tab-pane v-for="(item, index) in multiDimensionalCards" :key="index" :label="item.label" :name="item.name + index">
        <company-base-info v-if="item.name === '基本信息'" :company-name="dimensionalItem.companyName" :show-desc="true" />
        <company-other-info v-else-if="item.name === '基础信息'" :company-name="dimensionalItem.companyName" />
        <dimension-info v-else :company="{ company_name: dimensionalItem.companyName, key: item.name }" :select-key="selectKey" :select-type="selectType" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import DimensionInfo from "./DimensionInfo.vue";
import CompanyBaseInfo from "./CompanyBaseInfo.vue";
import CompanyOtherInfo from "./CompanyOtherInfo.vue";

export default {
  name: 'MultiDimensionalInfo',
  components: {
    CompanyOtherInfo,
    DimensionInfo,
    CompanyBaseInfo
  },
  props: {
    dimensionalItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    perKey: {
      type: String,
      default: ''
    },
    currentKey: {
      type: String,
      default: ''
    },
    selectType: {
      type: String,
      default: 'resources'
    }
  },
  computed: {
    multiDimensionalCards () {
      const multiDimensionalCardData = []

      this.dimensionalItem.dimension.forEach(item => {
        multiDimensionalCardData.push({ label: item.key === '基本信息' ? item.key : item.key + '(' + item.total + ')', name: item.key, dimension: [item.key] })
      })

      return multiDimensionalCardData
    }
  },
  watch: {
    currentKey (val) {
      if (val !== this.perKey) {
        this.activeName = ''
        this.selectKey = ''
      } else {
        this.selectKey = this.multiDimensionalCards[0].name
        this.activeName = this.multiDimensionalCards[0].name + '0'
      }

    },
    multiDimensionalCards: {
      immediate: true,
      handler (val) {
        if (this.multiDimensionalCards.length > 0 && this.currentKey === this.perKey) {
          this.selectKey = this.multiDimensionalCards[0].name
          this.activeName = this.multiDimensionalCards[0].name + '0'
        }
      }
    }
  },
  data () {
    return {
      activeName: '',
      selectKey: ''
    }
  },
  methods: {
    beforeLeave (activeName, oldActiveName) {
      // this.selectKey = ''
    },
    handleClick (tab, event) {
      this.selectKey = tab.name.replace(/\d+/g, '')
    }
  }
}
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/company_risks/common/MultiDimensionalInfo.vue